import React from 'react';
import { Link } from 'react-router-dom';
import { locations } from '../../data/locations';
import { FiTrendingUp, FiMapPin, FiMail, FiPhone } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-400 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 font-bold text-2xl text-white mb-6">
              <SafeIcon icon={FiTrendingUp} className="text-orange-500" />
              <span>AlbertaSEO</span>
            </Link>
            <p className="mb-6 leading-relaxed">
              Helping Alberta home service businesses dominate local search and AI results. 
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <SafeIcon icon={FiMapPin} className="text-orange-500" />
                <span>Calgary, AB (Headquarters)</span>
              </div>
              <div className="flex items-center gap-3">
                <SafeIcon icon={FiMail} className="text-orange-500" />
                <span>hello@albertaseo.pro</span>
              </div>
            </div>
          </div>

          {/* Locations */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Locations</h3>
            <ul className="space-y-3">
              {locations.map(loc => (
                <li key={loc.slug}>
                  <Link to={`/city/${loc.slug}`} className="hover:text-orange-400 transition-colors">
                    {loc.city} SEO
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Services</h3>
            <ul className="space-y-3">
              <li><Link to="/" className="hover:text-orange-400">Local SEO</Link></li>
              <li><Link to="/" className="hover:text-orange-400">AEO (AI Optimization)</Link></li>
              <li><Link to="/" className="hover:text-orange-400">Content Marketing</Link></li>
              <li><Link to="/" className="hover:text-orange-400">Web Design</Link></li>
              <li><Link to="/audit" className="hover:text-orange-400">Free SEO Audit</Link></li>
            </ul>
          </div>

          {/* CTA */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Get Your Free Audit</h3>
            <p className="mb-4 text-sm">See how your website scores against competitors.</p>
            <Link 
              to="/audit"
              className="inline-block w-full py-3 bg-orange-600 hover:bg-orange-700 text-white text-center font-bold rounded-lg transition-colors"
            >
              Start Audit
            </Link>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} Alberta SEO Pro. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;